import { Component, OnInit } from '@angular/core';
import { ApiJSONService, DomainBrandService, SeoService } from '@services/index';
import { HomeInterface } from '@interfaces/index';
import { Store } from '@ngrx/store';
import { AppState } from '@redux/app.reducers';
import * as ownActions from '@redux/actions';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  data: HomeInterface;
  dataHeader: any = [];
  dataAbout: any = [];
  dataFeatures: any = [];
  dataValues: any = [];

  constructor(
    private _apiJSONService: ApiJSONService,
    private _store: Store<AppState>,
    private _domainBrand: DomainBrandService,
    private _seo: SeoService
  ) {}

  /**
   * -------------------------------------------------------
   * @summary ngOnInit
   * @description  Inicializa funciones al cargar el
   * -------------------------------------------------------
   */
  ngOnInit(): void {
    this.getData();
  }

  /**
   * -------------------------------------------------------
   * @summary getData
   * @description Retorna la data page - home
   * -------------------------------------------------------
   */
  async getData() {
    await this._apiJSONService
      .getJSONHome('../assets/data/home.json')
      .subscribe(
        (resp) => {
          this.data = resp;
          this.dataHeader = this.data.header;
          this.dataAbout = this.data.aboutus;
          const about0 = this.dataAbout?.[0];
          if (about0?.description?.includes('__GROUP_YEARS__')) {
            about0.description = about0.description.replace(
              '__GROUP_YEARS__',
              String(this._domainBrand.groupTrajectoryYears)
            );
          }
          this.dataFeatures = this.data.features;
          this.dataValues = this.data.values;
          const browser = this.data.browser?.[0];
          const pageTitle = browser?.title
            ? `${browser.title} | ${this._domainBrand.documentTitle}`
            : this._domainBrand.documentTitle;
          this._seo.setPageMeta({
            title: pageTitle,
            description: browser?.description || undefined,
          });
          this._store.dispatch(ownActions.setLoading({ loading: false }));
        },
        (error) => {
          this._store.dispatch(ownActions.setLoading({ loading: true }));
          console.log(`error`, error);
        },
        () => {
        }
    );
  }
}
